import {
  IData_UserSummary,
  IData_UserSummary_Role,
  IData_UserSummary_FlatRoleObject,
} from '../types/schema/user_summary'

import {
  IRecord_Project,
} from '../types/schema/project'

import {
  IMeta_ProjectConfig_App_Config_Knowledgebase,
  IMeta_ProjectConfig_App_Config_Knowledgebase_Settings,
  IMeta_ProjectConfig_App_Config_Knowledgebase_Settings_Sorting,
  IRecord_KnowledgeBase,
  IRecord_KnowledgeBase_Summary,
} from '../types/schema/knowledgebase'

import {
  hasRoleAccessToType,
} from '../utils/role'

export const getProjectConfig = async (
  project: IRecord_Project,
) => {
  if(!project.meta || !project.meta.apps) throw new Error(`no project meta found`)
  const meta = project.meta
  const app = meta.apps.find(app => app.namespace == 'knowledgebase')
  if(!app || !app.config) throw new Error(`knowledgebase config not found`)
  const config = app.config as IMeta_ProjectConfig_App_Config_Knowledgebase
  return config
}

export const getProjectTypeConfig = async (
  project: IRecord_Project,
  type: string,
) => {
  const config = await getProjectConfig(project)
  const typeConfig = config.types.find(t => t.name == type)
  if(!typeConfig) throw new Error(`${type} type not found`)
  return typeConfig
}

export const getUserSummaryRoles = (userSummary: IData_UserSummary): IData_UserSummary_FlatRoleObject[] => {
  return userSummary.flatRoles.filter(role => role.name.startsWith('knowledgebase:'))
}

export const hasUserSummaryTypeAccess = (userSummary: IData_UserSummary, type: string, access = 'reader'): boolean => {
  const baseRoles = userSummary.flatRoles.filter(role => role.name.startsWith(`knowledgebase:${access}`))
  return baseRoles.find(role => hasRoleAccessToType(role, type)) ? true : false
}

const DEFAULT_SORTING: IMeta_ProjectConfig_App_Config_Knowledgebase_Settings_Sorting = {
  field: 'created',
  direction: 'desc',
  manualIds: [],
}

const DEFAULT_SETTINGS: IMeta_ProjectConfig_App_Config_Knowledgebase_Settings = {
  sorting: DEFAULT_SORTING,
}

export const getDefaultSortSettings = (
  sortSettings = DEFAULT_SORTING,
) => sortSettings


export const getDefaultSettings = (
  settings = DEFAULT_SETTINGS,
) => settings

export const sortArticles = (
  data: (IRecord_KnowledgeBase | IRecord_KnowledgeBase_Summary)[],
  sortSettings: IMeta_ProjectConfig_App_Config_Knowledgebase_Settings_Sorting,
): IRecord_KnowledgeBase[] => {
  const retData = [].concat(data)
  if(sortSettings.field == 'name') {
    retData.sort((a, b) => {
      const aName = a.name.toLowerCase().replace(/\W/g, '')
      const bName = b.name.toLowerCase().replace(/\W/g, '')
      if(aName > bName) return sortSettings.direction == 'asc' ? 1 : -1
      if(aName < bName) return sortSettings.direction == 'asc' ? -1 : 1
      return 0
    })
    return retData
  }
  else if(sortSettings.field == 'created') {
    retData.sort((a, b) => {
      const aVal = new Date(a.created_at).getTime()
      const bVal = new Date(b.created_at).getTime()
      if(aVal > bVal) return sortSettings.direction == 'asc' ? 1 : -1
      if(aVal < bVal) return sortSettings.direction == 'asc' ? -1 : 1
      return 0
    }) 
    return retData
  }
  else if(sortSettings.field == 'manual') {
    const manualIds = sortSettings.manualIds || []
    const manualIdMap = manualIds.reduce((acc, id) => {
      acc[id] = true
      return acc
    }, {})
    const dataMap = retData.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {})
    return manualIds
      .map(id => dataMap[id])
      .filter(i => i)
      .concat(retData.filter(item => !manualIdMap[item.id]))
  }
  else {
    return retData
  }
}